export const ADMIN_ROLE_UUID = "b4461d9a-288c-4e2f-bff7-b3ff663e5153"
export const USER_ROLE_UUID = "c6178db4-6976-4f98-b607-dba8f2431056"
export const REGISTER_ROLE_UUID = "230e386e-e1dc-43d2-84c4-ed4c4950ee78"
export const BLOCKED_ROLE_UUID = "159e66d4-049c-45ba-9be3-c2e6d9638f2b"